import { useTranslation } from 'react-i18next';
import { services } from '@/mocks/landingData';

export default function ServicesSection() {
  const { t } = useTranslation();

  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="services" className="relative w-full py-20 md:py-32 bg-dark-800">
      <div className="w-full px-4 md:px-6 lg:px-12">
        <div className="mb-12 md:mb-16">
          <h2 className="font-display font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white">
            {t('services.title1')}{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-blue to-neon-purple">
              {t('services.title2')}
            </span>
          </h2>
          <p className="mt-4 text-sm md:text-base text-gray-400 max-w-xl">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {services.map((service) => (
            <div
              key={service.id}
              className="group relative p-5 md:p-6 rounded-2xl bg-dark-400 border border-white/5 hover:border-white/15 transition-all duration-500 hover:-translate-y-1 cursor-pointer"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 rounded-xl bg-gradient-to-br ${service.gradient} flex items-center justify-center mb-5 shadow-lg`}>
                <i className={`${service.icon} text-white text-xl md:text-2xl`} />
              </div>
              <h3 className="text-lg md:text-xl font-display font-bold text-white mb-3">
                {t(`services.${service.id}_title`)}
              </h3>
              <p className="text-xs md:text-sm text-gray-400 leading-relaxed mb-5">
                {t(`services.${service.id}_desc`)}
              </p>
              <button
                onClick={scrollToContact}
                className="flex items-center gap-2 text-xs md:text-sm text-neon-blue font-medium bg-transparent border-none cursor-pointer hover:opacity-80 transition-opacity duration-300 whitespace-nowrap"
              >
                <span>{t('services.getStarted')}</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-300" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
